import { gql } from '@apollo/client';

export const UPDATE_ORDER = gql`
  mutation UpdateOrder($updateOrderInput: UpdateOrderInput!) {
    updateOrder(updateOrderInput: $updateOrderInput) {
      __typename
      ... on UpdateOrdersSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
